<div [style.padding]="linePadding">
<div>
  <vsf-title-box
    [titleInfo]="titleInfo"
    [forComponent]="true">
  </vsf-title-box>
</div>
<div class="collections-grid">
  <div class="collections-row" *ngFor="let group of groupedCollections; trackBy: trackByGroup">
    <vsf-two-collection-card-v2
      [collectionA]="group[0]"
      [collectionB]="group[1]"
      [colorConfig]="colorConfig"
      class="card">
    </vsf-two-collection-card-v2>
  </div>
</div>
</div>
